module.exports = __webpack_public_path__ + "img/c00_buildingtechstonesplitting_Normal_ua.1c24b9ee.webp";